import { PasscodeListsState } from './types';

export const initialState: PasscodeListsState = {
  passcodeList: null,
  loadingPasscodeList: false,

  passcodeLists: [],
  loadingPasscodeLists: false,

  passcodeListMembers: [],
  loadingPasscodeListMembers: false,

  passcodelistMemberListId: null,

  passcodeListMemberCount: 0,
  loadingPasscodeListMemberCount: false,

  passcodeListAssociatedEvents: [],
  passcodeListAssociatedEventsDetails: [],

  memberPasscodeLists: {},
  loadingMemberPasscodeLists: false,

  magicLinkRegistrationsPasscodeList: null,

  passcodeListMemberRegistrantDetails: {},
};
